/**
 * WHICH WING OWNS EACH ADDRESS (Peter, on the view-as walk 2026-08-29: "when you click on
 * something you get lost, you can't get back"). The old door said Home on EVERY page, so
 * from Studio -> Maintenance, "back" skipped the wing and dumped you at Home — a back door
 * that lies about where back is. The door now names the REAL parent, in words — no arrow
 * glyphs, his standing rule — and the bar lights the wing you are inside.
 */
const PARENT: Record<string, { label: string; to: string }> = {
  '/reviews':     { label: 'Grow',   to: '/grow' },
  '/spotlight':   { label: 'Grow',   to: '/grow' },
  '/tickets':     { label: 'Studio', to: '/my-studio' },
  '/documents':   { label: 'Studio', to: '/my-studio' },
  '/academy':     { label: 'Studio', to: '/my-studio' },
  '/suggestions': { label: 'Studio', to: '/my-studio' },
  '/refer':       { label: 'Studio', to: '/my-studio' },
  '/help':        { label: 'Studio', to: '/my-studio' },
  '/support':     { label: 'Studio', to: '/my-studio' },
};
export function parentOf(pathname: string): { label: string; to: string } {
  const base = '/' + (pathname.split('/')[1] ?? '');
  return PARENT[base] ?? { label: 'Home', to: '/' };
}
/** The bar door that should light up for an address — a wing's children light the wing. */
export function activeBarTo(pathname: string): string {
  const base = '/' + (pathname.split('/')[1] ?? '');
  const parent = PARENT[base];
  return parent ? parent.to : base;
}

